import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-[calc(100vh_-_9rem)] w-[300px] pb-1" }
const _hoisted_2 = { class: "flex h-8 w-full items-center justify-between bg-lightgray px-4" }
const _hoisted_3 = {
  class: /*@__PURE__*/_normalizeClass(`flex h-full items-center justify-end space-x-2 `)
}
const _hoisted_4 = { class: "mb-2 flex h-[7%] w-full space-x-2 p-2" }
const _hoisted_5 = {
  key: 1,
  class: "flex h-full w-full space-x-2"
}
const _hoisted_6 = {
  key: 2,
  class: "flex h-full w-full space-x-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_custom_table = _resolveComponent("custom-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Tags", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'times'],
          class: "cursor-pointer text-darkgrey hover:text-dark",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-tag-actions')))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.isTagCreateMode && !_ctx.isTagEditMode)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            icon: ['fas', 'plus'],
            text: 'Create tag',
            size: "full",
            onExecuteMethod: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-create-tag-modal')))
          }))
        : _createCommentVNode("", true),
      (_ctx.isTagCreateMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_the_button, {
              icon: ['fas', 'save'],
              text: _ctx.$t('Save'),
              size: "full",
              onExecuteMethod: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('save-tag')))
            }, null, 8, ["text"]),
            _createVNode(_component_the_button, {
              text: _ctx.$t('Cancel'),
              size: "full",
              variant: "outline",
              onExecuteMethod: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancel-creating')))
            }, null, 8, ["text"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isTagEditMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_the_button, {
              icon: ['fas', 'save'],
              text: _ctx.$t('Save'),
              size: "full",
              onExecuteMethod: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('save-edit-tag')))
            }, null, 8, ["text"]),
            _createVNode(_component_the_button, {
              text: _ctx.$t('Cancel'),
              size: "full",
              variant: "outline",
              onExecuteMethod: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('cancel-tag-edit-mode')))
            }, null, 8, ["text"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_component_custom_table, {
      key: _ctx.tags.length,
      options: _ctx.options,
      "remove-table-header": true,
      "table-data": _ctx.tags,
      "table-headers": _ctx.tableHeaders,
      "table-height": "90%",
      onSelectedRows: _ctx.getSelectedRow
    }, null, 8, ["options", "table-data", "table-headers", "onSelectedRows"]))
  ]))
}